import { FC } from 'react';

import { Button, Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';
import { cn } from '@distribute/frontend/utils';

type Props = {
  className?: string;
  onClear: () => void;
  name: string;
};

export const SearchModalNotFound: FC<Props> = ({
  className,
  onClear,
  name,
}) => {
  return (
    <div
      className={cn(
        'w-full h-full flex flex-col items-center justify-center gap-y-4 text-center',
        className
      )}
    >
      <div className="relative flex-shrink-0 p-3 rounded-[10px] border border-gray-200 bg-white shadow-xs">
        <Icon
          glyph={IconMap.SearchMd}
          width={24}
          height={24}
          className="text-gray-700"
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-y-1 max-w-88">
        <p className="font-semibold text-gray-900 text-md">
          {`No ${name} found`}
        </p>
        <p className="text-gray-600 text-sm">
          We cannot find what you need, please try to adjust your search
          criteria.
        </p>
      </div>
      <Button
        variant="text"
        color="secondary"
        size="lg"
        onClick={onClear}
        className="font-semibold shadow-xs"
      >
        Clear search
      </Button>
    </div>
  );
};
